import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    puestos: [],
  },

  getters: {
    getPuestos: (state) => state.puestos,
  },

  mutations: {
    SET_PUESTOS(state, puestos) {
      state.puestos = puestos;
    },
  },

  actions: {
    async fetchPuestos({ commit }) {
      await axios
        .get('/EonCloud/common/puestos')
        .then((response) => {
          commit('SET_PUESTOS', response.data.data);
        });
    },

    async fetchPuestosByDependencia({ commit }, dependencia) {
      await axios
        .get(`/EonCloud/common/dependencias/${dependencia.id}/puestos`)
        .then((response) => {
          commit('SET_PUESTOS', response.data.data);
        });
    },
  },
};
